(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .factory('CrmTagSearch', CrmTagSearch);

    CrmTagSearch.$inject = ['$resource'];

    function CrmTagSearch($resource) {
        var resourceUrl =  'api/_search/crm-tags/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
